module.exports = __webpack_public_path__ + "img/centered-logo-nav-nissan.3bd768ad.png";